import styled from 'styled-components';
import { lighten } from 'polished';

import 'antd/lib/spin/style/index.css';
import 'antd/lib/select/style/index.css';
import 'antd/lib/tabs/style/index.css';

export const BreadcumbsContainer = styled.div`
  margin: 0 auto 5px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    div.boxSearch {
      margin-left: 20px;
      form {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      label {
        width: 200px;
        height: 33.4px;
        padding: 0 10px;
        border-radius: 3px;
        box-shadow: inset 0px 1px 0px 0px #c7c7c794;
        border: solid 1px #c7c7c794;
        background: #ffffff;
        display: flex;
        flex-direction: row;

        align-items: center;
      }
      input {
        border: 0;
        color: #74a50a;
        margin: 0 0 0 5px;
        &::placeholder {
          color: #444;
        }
      }
      button {
        margin-left: 4px;
      }
      button.voltar {
        width: 90px;
        height: 32px;
        border-radius: 3.5px;
        background-color: #235f6e;
        border: none;
        color: #ffffff;
        margin-left: 20px;
      }

      div.ant-select {
        margin-right: 10px;

        .ant-select-focused .ant-select-selection,
        .ant-select-selection:focus,
        .ant-select-selection:active {
          border-color: #74a50a;
          border-right-width: 1px !important;
          outline: 0;
          -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
          box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
        }

        .ant-select-arrow {
          font-size: 12px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.28;
          -webkit-letter-spacing: 0.01px;
          -moz-letter-spacing: 0.01px;
          -ms-letter-spacing: 0.01px;
          letter-spacing: 0.01px;
          text-align: left;
          color: #619b30;
        }
      }
    }
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
`;

export const BoxContentHeader = styled.div`
  padding: 10px 20px;
  align-self: center;
  height: 30px;
  div {
    svg {
      color: #dddbdb;
    }

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      color: #727272;
    }
  }

  div.dataHoraHeader {
    padding-left: 30px;
  }
`;

export const BoxList = styled.div`
  width: '100%';
  min-height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 15px;
  color: #235f6e;

  div.evento {
    min-height: 70px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 15px;
    letter-spacing: 0px;
    text-align: left;
    color: #235f6e;
  }

  div.descricao {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;

    button {
      border: none;
      background-color: transparent;
      color: #235f6e;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  div.buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    button {
      color: #fff;
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 34px;
      border-radius: 3.5px;
      background-color: #74a50a;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      text-align: right;
      color: #ffffff;
      a {
        color: #fff;
        margin: 0;
        padding: 0;
        display: block;
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      svg,
      img {
        margin-right: 5px;
      }
      &:first-child {
        width: 114px;
        &:hover {
          background-color: ${lighten(0.1, '#74a50a')};
        }
      }
      &:nth-child(2) {
        margin-left: 20px;
        width: 157px;
        background-color: #398ca1;
        &:hover {
          background-color: ${lighten(0.1, '#398ca1')};
        }
      }
      &:last-child {
        width: 77px;
        background-color: #235f6e;

        margin-left: 20px;
        &:hover {
          background-color: ${lighten(0.1, '#235f6e')};
        }
      }
    }
  }

  div.descriptionGrid {
    display: grid;
    grid-template-columns: 3fr 1fr;
  }

  div.buttonDetalhes {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      > span {
        padding-left: 4px;
      }
      &:hover {
        text-decoration: none;
      }
    }
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const ModalContainer = styled.div`
  div.ModalBody {
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 20px 20px 20px;
    background-color: #f3f3f3;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    letter-spacing: 0.01px;
    color: #235f6e;
    div {
      width: 100%;

      span {
        font-size: 13px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        text-align: left;
        color: #235f6e;
        display: block;
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;

        letter-spacing: 0.01px;
        text-align: left;
        color: #235f6e;
      }
    }

    div.data {
      > div {
        margin-bottom: 20px;
        p {
          margin: 2px;
        }
        span {
          margin: 0;
        }
      }
    }
  }

  div.ModalBodyAnterior {
    background-color: #e8ece1;
  }

  div.tabsContainer {
    .ant-tabs-tab {
      &:hover {
        color: #74a50a;
      }
    }
    .ant-tabs-nav .ant-tabs-tab-active {
      color: #74a50a;
      font-weight: 500;
    }

    .ant-tabs-ink-bar {
      background-color: #74a50a;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  margin-bottom: 10px;
  h2 {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    span {
      color: #235f6e;
      font-weight: bold;
    }
  }
`;

export const ModalFooter = styled.div`
  width: 480px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ButtonModal = styled.button`
  width: 168.8px;
  height: 40.1px;
  border-radius: 3.5px;
  border: none;
  background-color: ${props => (props.cancel ? '#FFF' : '#74a50a')};
  color: ${props => (props.cancel ? '#999999' : '#f7f7f7')};
  margin: 20px 10px 0px 10px;
`;
